import type { HTMLAttributes, PropsWithChildren } from "react";

import { DefinedDefaults } from "@/ui/lib/types";
import { TIconKey } from "../Icon";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const BADGE_VARIANT_CLASS_MAP = {
  default: "border-component-badge-default bg-component-badge-default text-foreground-inverse",
  secondary: "border-component-badge-secondary bg-component-badge-secondary text-foreground",
  outline: "border-component-badge-outline bg-component-badge-outline text-foreground",
  price: "border-component-badge-price bg-component-badge-price text-foreground",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TBadgeVariant = keyof typeof BADGE_VARIANT_CLASS_MAP;

export type TBadgeProps = {
  variant?: TBadgeVariant;
  icon?: TIconKey;
} & PropsWithChildren & HTMLAttributes<HTMLDivElement>;

type TBadgeDefaultProps = DefinedDefaults<TBadgeProps, "variant">;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const BADGE_DEFAULTS = {
  variant: "default",
} satisfies TBadgeDefaultProps;
